import { render, staticRenderFns } from "./Restart.vue?vue&type=template&id=6ec24f7d&"
import script from "./Restart.vue?vue&type=script&lang=js&"
export * from "./Restart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports